export const content = {
  dataDiscountPrefix: 'Data discount up to',
  dataDiscountSuffix: 'p/m',
  cancelAnytime: '1 month plan, cancel anytime',
  noCreditCheck: 'No credit check',
  fastData: 'Fast 5G & 4G data',
  tethering: 'Tethering/personal hotspot included',
  unlimitedCallsTexts: 'Unlimited calls & texts',
  checkmarkAlt: 'checkmark',
}
